export default __webpack_public_path__ + "static/media/Group-icon.c0bc3003.png";